import Vue from 'vue'
import axios from 'axios'
import { HTTP } from '@/utils/http-common'
import { redirect } from '@/utils/common'

export default {
    list (parent, page) {
        if (page === 0) {
            return HTTP.get('/functions/manage/')
        } else if (page !== null) {
            return HTTP.get(page)
        } else {
            return {}
        }
    },
    get (id, parent) {
        return HTTP.get('/functions/manage/' + id + '/')
            /*
                .then(function (response){
                }).catch((error)=>{
                  parent.$store.commit('push', {msg: 'error '+error.response.status, color: 'error'});
                  console.log('error '+error.response.status+' - refer to this file and line --->');
                }) */
    },
    delete (id, parent) {
        return new Promise((resolve, reject) => {
            return HTTP.delete('/functions/manage/' + id + '/')
                .then((response) => {
                    parent.$store.commit('push', { msg: 'Function deleted', color: 'success' })
                    return resolve(response)
                }).catch((error) => {
                    parent.$store.commit('push', { msg: 'error ' + error.response.status, color: 'error' })
                    console.log('error ' + error.response.status + ' - refer to this file and line --->')
                    return reject(error)
                })
        })
    },
    clone (hmdFunction, parent, targetProject, cloneName = null) {
        const params = { target_project: targetProject }
        params.name = cloneName || hmdFunction.name
        return HTTP.post(`functions/manage/${hmdFunction.id}/clone/`, params).then((result) => {
            parent.$store.commit('push', { msg: 'Function cloned successfully', color: 'success' })
            redirect(`projects/${parent.$route.params.project}/view/function/${result.data.id}`)
            return result
        }).catch((error) => {
            parent.$store.commit('push', { msg: error, color: 'error' })
            return error
        })
    },
    get_api_embed (id, parent) {
        return HTTP.get('/gateway/api/function/' + id + '/apiembed/')
    },
    runFunction (id, params, useData, parent) {
        if (!useData) {
            return HTTP.get('/functions/manage/' + id + '/invoke/', {timeout:-1})
        } else {
            return HTTP.post('/functions/manage/' + id + '/invoke/', typeof params === 'string' ? JSON.parse(params) : params, {timeout:-1})
        }
    },
    interruptKernel (id, parent) {
        return new Promise((resolve, reject) => {
            HTTP.post('/functions/manage/' + id + '/spec/', { action: 'interrupt_kernel' }).then(r => {
                resolve(r)
            }).catch(err => { reject(err) })
        })
    },
    restartKernel (id, parent) {
        return new Promise((resolve, reject) => {
            HTTP.post('/functions/manage/' + id + '/spec/', { action: 'restart_kernel' }).then(r => {
                resolve(r)
            }).catch(err => { reject(err) })
        })
    },
    deploy (func, cells, parent) {
        return new Promise((resolve, reject) => {
            HTTP.post('/functions/manage/' + func.id + '/deploy/', { cells: cells })
                .then((response) => {
                    parent.$store.commit('push', { msg: 'function updated', color: 'success' })
                    resolve(response)
                }).catch((error) => {
                    parent.$store.commit('push', { msg: 'error ' + error.response.status, color: 'error' })
                    console.log('error ' + error.response.status + ' - refer to this file and line --->')
                    reject(error)
                })
        })
    },
    update (func, parent) {
        HTTP.put('/functions/manage/' + func.id + '/', func)
            .then((response) => {
                parent.$store.commit('push', { msg: 'function updated', color: 'success' })
                parent.saveLoadingButton = false
                parent.lastSavedCode = func.content
            }).catch((error) => {
                parent.$store.commit('push', { msg: 'error ' + error.response.status, color: 'error' })
                console.log('error ' + error.response.status + ' - refer to this file and line --->')
                parent.saveLoadingButton = false
            })
    },
    checkFunctionDeployed (id, parent) {
        return HTTP.get('functions/manage/' + id + '/status/')
    },
    create (id, parent) {
        return new Promise((resolve, reject) => {
            HTTP.post('/functions/manage/', id)
                .then((response) => {
                    return resolve(response)
                }).catch((error) => {
                    parent.$store.commit('push', { msg: _.join(_.map(error.response.data, (o, i) => i + ' : ' + o), '\n'), color: 'error' })
                        // console.log('error '+error.response.status+' - refer to this file and line --->');
                    return reject(error)
                })
        })
    },
    addPermission (parent, hmdFunction, user, permission) {
        if (typeof (hmdFunction.permissions.find(x => x.username === user)) !== 'undefined') {
            parent.$store.commit('push', { msg: 'User already in the team', color: 'error' })
        } else {
            HTTP.post('permissions/function/' + hmdFunction.id + '/', {
                username: user,
                perms: permission,
            }).then((response) => {
                parent.$store.commit('push', { msg: 'Invite sent', color: 'success' })
                parent.$emit('modifyPermissions', { type: 'addPermission', user: user, permission: permission })
            }).catch((error) => {
                if (error.response.status === 404) {
                    parent.$store.commit('push', { msg: 'Username does not exist', color: 'error' })
                } else {
                    parent.$store.commit('push', { msg: 'error ' + error.response.status, color: 'error' })
                    console.log('error ' + error.response.status + ' - refer to this file and line --->')
                }
            })
        }
    },
    changePermission (parent, hmdFunction, user, permission) {
        HTTP.post('permissions/function/' + hmdFunction.id + '/', {
            username: user,
            perms: permission,
        }).then((response) => {
            parent.$store.commit('push', { msg: 'Permissions updated', color: 'success' })
            parent.$emit('modifyPermissions', { type: 'changePermission', user: user, permission: permission })
        }).catch((error) => {
            if (error.response.status === 404) {
                parent.$store.commit('push', { msg: 'Username does not exist', color: 'error' })
            } else {
                parent.$store.commit('push', { msg: 'error ' + error.response.status + ' in FunctionService.js @changePermission', color: 'error' })
                console.log('error ' + error.response.status + ' - refer to this file and line --->')
            }
        })
    },
    deletePermission (parent, hmdFunction, user) {
        HTTP.delete('permissions/function/' + hmdFunction.id + '/username/' + user.username + '/')
            .then((response) => {
                parent.$store.commit('push', { msg: 'Permission deleted', color: 'success' })
                parent.$emit('modifyPermissions', { type: 'deletePermission', user: user })
            }).catch((error) => {
                parent.$store.commit('push', { msg: 'Error when deleting the user\'s permissions', color: 'error' })
                console.log('error ' + error.response.status + ' - refer to this file and line --->')
            })
    },
    getMetrics (parent, id, refresh = false) {
        var metrics_url = 'metrics/function/' + id + '/weekly/'
        if (refresh) { metrics_url = 'metrics/function/' + id + '/weekly_refresh/' }
        return HTTP.get(metrics_url)
    },
    createTemplate (template, parent) {
        HTTP.post('functions/template/manage/', template)
            .then((response) => {
                parent.$store.commit('push', { msg: 'Template created', color: 'success' })
                parent.$emit('loadTemplates')
                parent.dialog = false
            }).catch((error) => {
                parent.$store.commit('push', { msg: error, color: 'error' })
            })
    },
    getTemplates (runtime) {
        return HTTP.get('functions/template/manage/?runtime=' + runtime)
    },
    searchUsers (search, parent) {
        return HTTP.get('/permissions/users/search/?username=' + search)
    },
    getLogs (id, parent) {
        return HTTP.get('/functions/manage/' + id + '/debug/')
    },
    getApi (runtime, apiName) {
        return HTTP.get('/functions/access/apicode/?runtime=' + runtime + '&name=' + apiName)
    },
    getApiList (runtime) {
        return HTTP.get('/functions/access/apilist/?runtime=' + runtime)
    },
    getData (runtime, datasetId) {
        return HTTP.get('functions/access/datasetcode/?runtime=' + runtime + '&hmd_id=' + datasetId)
    },
    getDataList () {
        return HTTP.get('functions/access/datasetlist')
    },
    setFunction (func, parent) {
        return HTTP.post('dashboard/setfunction/', func).then(() => {
            parent.form.isSavingDashboardFunction = false
        }).catch((error) => {
            parent.$store.commit('push', { msg: error + '', color: 'error' })
            parent.form.isDashboardFunction = !parent.form.isDashboardFunction
            parent.form.isSavingDashboardFunction = false
        })
    },
    unsetFunction (parent) {
        return HTTP.delete('dashboard/setfunction/').then(() => {
            parent.form.isSavingDashboardFunction = false
        }).catch((error) => {
            parent.$store.commit('push', { msg: error + '', color: 'error' })
            parent.form.isDashboardFunction = !parent.form.isDashboardFunction
            parent.form.isSavingDashboardFunction = false
        })
    },
    // ENVIRONMENT SERVICES
    updateEnvironment (env_to_edit, env) {
        return HTTP.put(`functions/environments/${env_to_edit}/`, { name: env.name, variables: env.variables })
    },
    createEnvironment (env, fn) {
        return HTTP.post('functions/environments/', env)
    },
    deleteEnvironment (env) {
        return HTTP.delete('functions/environments/' + env.id + '/')
    },
    getEnvironments () {
        return HTTP.get('functions/environments')
    },
    getEnvironment (envId) {
        return HTTP.get(`functions/environments/${envId}/`)
    },
    saveFunctionEnvironmentPreference (parent, env, fn) {
        // We need to set the API URL and the post parameters
        return HTTP.post('functions/manage/' + fn.id +'/env/', {environment: env, function: fn}).then(() => {
            parent.$store.commit('push', { msg: 'Saved environment preference with success !', color: 'success' })
        }).catch((error) => {
            parent.$store.commit('push', { msg: 'Error while saving environment preference for this function (' + error + ')', color: 'error' })
        })
    },

    // functions/access/api/?runtime='+runtime
    // functions/access/data/?runtime='+runtime
    // functions/access/datalist
}
